import CreateArtistContainer from "../containers/CreateArtistContainer";

const CreateArtistPage = () => {
  return (
    <CreateArtistContainer />
  );
};

export default CreateArtistPage;
